// eslint-disable-next-line no-restricted-exports
export { default } from './accordion';
export { default as accordionConfig } from './accordion.config';
